export default "/assets/website/images/store-2.jpeg?45df17abab70862c454ae64e0eae8748";